/**
 * @fileoverview Taskflow - Layout Header component React interface
 * @author Qiwen Luo (qluo@yext.com)
 */

import {Link} from '/ui/components/link/link';
import * as Types from '/ui/components/taskflow/models';
import {classNames} from '/ui/lib/classnames';

import * as styles from '/ui/components/taskflow/layoutHeader/layoutHeader.module.scss';

/**
 * @param {{
 *   icon?: React.ReactNode,
 *   title: string,
 *   description: string,
 *   resourceLink?: Types.ResourceLinkType,
 *   headerCTAs?: !Array<React.ReactNode>,
 *   isMobile?: boolean,
 * }} props
 * @return {React.ReactElement}
 */
export function LayoutHeader({
  icon,
  title,
  description,
  resourceLink,
  headerCTAs,
  isMobile = false,
}) {
  return (
    <div className={styles.container}>
      {icon
        && <div className={styles.icon}>{icon}</div>
      }
      <div className={styles.titleContainer}>
        <div className={styles.title}>{title}</div>
        <div className={classNames(styles.description, {[styles.mobileLayout]: isMobile})}>
          {description}
        </div>
        {resourceLink
          && (
            <div className={classNames(styles.resourcelink, {[styles.mobileLayout]: isMobile})}>
              <Link
                external={resourceLink.external}
                href={resourceLink.src}
                icon={resourceLink.icon && resourceLink.icon}
              >
                <div className={styles.resourcelinkDisplayText}>
                  {resourceLink.displayText ? resourceLink.displayText : resourceLink.src}
                </div>
              </Link>
            </div>
          )
        }
        {headerCTAs
          && <div className={styles.headerCtas}>
            {
              headerCTAs.map((cta, index) => {
                return (
                  <div key={index} className={styles.cta}>
                    {cta}
                  </div>
                );
              })
            }
          </div>
        }
      </div>
    </div>
  );
}
